import React from 'react'
import api, { METHODS, objectToString } from './api'

import GlobalNotification from 'live/services/global-notification'
import { Notification } from '../common/components/Notification/Notification'
import i18n from 'live/services/i18n'
import { Recipient } from '../common/types/form'

interface Result {
    success: true
    count: 1
    config: string
}

export default async function getPreviewBody(
    uid: string,
    recipient: Recipient = {
        enabled: true,
        name: '',
        recipients: [],
        lookups: {}
    },
    span?: string
): Promise<string> {
    try {
        const requestReport = await api<Result>(`previewBody/${uid}`, METHODS.POST, objectToString({ recipient, span }))

        if (!requestReport.success) {
            GlobalNotification.error(<Notification title={i18n('Error')}>{'unknown error'}</Notification>, 20)
            console.error(requestReport)
        }

        return requestReport.config
    } catch (error) {
        GlobalNotification.error(
            <Notification title={i18n('Error trying to get Report: ')}>
                <tr>
                    <strong>Report id: </strong> {uid}
                </tr>
                {error}
            </Notification>,
            20
        )

        console.error(error)

        return null
    }
}
